import { translations } from '@janus.team/janus-particles';
import React from 'react';

export const Section = () => {
  const t = translations.useT();
  return (
    <div className="d-flex justify-content-center my-10 py-10">
      <div className="spinner-border spinner-border-lg" role="status">
        <span className="visually-hidden">{t('Loading...')}</span>
      </div>
    </div>
  );
};